import { DropDownButton as KDropDownButton } from "@progress/kendo-react-buttons";

import type { PropsWithChildren } from "react";
import type { DropDownButtonProps as KDropDownButtonProps } from "@progress/kendo-react-buttons";

import "./DropDownButton.scss";

export interface DropDownButtonProps extends KDropDownButtonProps {
  title?: string;
}

export const DropDownButton = function render(props: PropsWithChildren<DropDownButtonProps>) {
  const { look, className, popupSettings, ...otherProps } = props;
  const flatOrDefinedLook = look || "flat";
  const popClass = `${popupSettings?.popupClass} tc-dropdownbutton-popup`;
  const popSettings = { ...popupSettings, ...{ popupClass: popClass } };
  return (
    <span title={props.title}>
      <KDropDownButton
        className={`tc-dropdownbutton ${className}`}
        fillMode={flatOrDefinedLook}
        popupSettings={popSettings}
        {...otherProps}
      >
        {props.children}
      </KDropDownButton>
    </span>
  );
};
